var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1734 0C4.65058 0 0.173431 4.47716 0.173431 10V29.8266C0.173431 35.3494 4.6506 39.8266 10.1734 39.8266H30C35.5229 39.8266 40 35.3494 40 29.8266V10C40 4.47715 35.5229 0 30 0H10.1734ZM37.2082 11.4093C36.7984 9.87616 35.5912 8.6689 34.058 8.2592C31.279 7.51447 20.1365 7.51447 20.1365 7.51447C20.1365 7.51447 8.9941 7.51447 6.21498 8.2592C4.68216 8.6689 3.47462 9.87616 3.06485 11.4093C2.32047 14.1881 2.32047 19.9859 2.32047 19.9859C2.32047 19.9859 2.32047 25.7837 3.06485 28.5622C3.47462 30.0953 4.68216 31.3029 6.21498 31.7126C8.9941 32.457 20.1365 32.457 20.1365 32.457C20.1365 32.457 31.279 32.457 34.058 31.7126C35.5912 31.3029 36.7984 30.0953 37.2082 28.5622C37.9529 25.7837 37.9529 19.9859 37.9529 19.9859C37.9529 19.9859 37.9529 14.1881 37.2082 11.4093ZM16.5732 25.3308L25.8305 19.9859L16.5732 14.6409V25.3308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.a9622de3b8bb442fc5e3b955e3985f94.svg";
export { ForwardRef as ReactComponent };